/**
 * Felder und Abrufe aus dem Persona-Umbau D (28.10.2026) — als Modul-Erweiterung bzw. eigener Abruf statt in
 * `helpers/auswertungenData.ts` (die Datei bearbeiten parallel andere Kapitel). Backend:
 * `kanaeleService.bezahlquotenVergleich`, `werbeflaechenService.werbeflaechenKern` / `dmHaelften`. Alle Felder optional,
 * damit die Seite ein älteres Backend aushält (Deploy-Reihenfolge, Cache).
 */
import { fetchData } from '../../../helpers/apiUtils';
import type { VergleichsBasis, Zeitfenster } from '../../../helpers/auswertungenData';

/** Bezahlquote der Kopf-Kachel gegen einen Vergleichszeitraum (Regel wie P2 „Wer bestellt — und wer zahlt"). */
export interface BezahlquotenVergleich {
  pay_rate: number | null;
  mature_anfos: number;
  mature_paid: number;
  pay_rate_basis: number | null;
  mature_anfos_basis: number;
  mature_paid_basis: number;
  /** Prozentpunkte, ungerundet. */
  delta_pp: number | null;
  test: { z: number | null; p: number; p_holm: number; flag: 'up' | 'down' | null } | null;
}

/** Summe mehrerer Werbeflächen (nur Zeilen mit Kontaktzahl, Anfos ohne vorläufige). */
export interface FlaechenSumme {
  keys: string[];
  kontakte: number;
  anfos: number;
  wert_summe: number;
  wert_je_1000: number | null;
  anfos_je_1000: number | null;
}

export interface WerbeflaechenKern {
  direkt_mailing: FlaechenSumme;
  heat_up: FlaechenSumme;
  faktor: number | null;
}

/** Direkt-Mailings der letzten 3 Monate gegen die 3 Monate davor (nach Versandtag). */
export interface DmHaelften {
  letzte_von: string;
  davor_von: string;
  /** Versandschluss, exklusiv. */
  versand_bis: string;
  letzte: FlaechenSumme;
  davor: FlaechenSumme;
  delta_kontakte: number | null;
  delta_wert_je_1000: number | null;
}

declare module '../../../helpers/auswertungenData' {
  interface KanaeleAntwort {
    bezahlquote_vergleich?: Record<VergleichsBasis, BezahlquotenVergleich>;
    /** Reife Spannen, über die die Bezahlquote rechnet: jetzt bis 60 Tage vor dem Stichtag, die Basis dieselbe Spanne verschoben. */
    reif_vergleich?: Record<'jetzt' | VergleichsBasis, Zeitfenster | null>;
  }
  interface WerbeflaechenAntwort {
    kern?: WerbeflaechenKern;
  }
}

export async function fetchDmHaelften(): Promise<DmHaelften> {
  const res = await fetchData<DmHaelften>('/api/auswertungen/kanaele/direkt-mailing-haelften');
  if (!res.success || res.data === undefined) throw new Error(res.error || 'Laden fehlgeschlagen');
  return res.data;
}
